import { Search as Search_kojaro } from './Search.kojaro';
import { Search as Search_phosphor } from './Search.phosphor';
import { Search as Search_zoomg } from './Search.zoomg';
import { Search as Search_zoomit } from './Search.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return Search_kojaro;

    case 'zoomg':
      return Search_zoomg;

    case 'phosphor':
      return Search_phosphor;

    default:
      return Search_zoomit;
  }
};

export const Search = IconRenderer();
